import React, {Component} from "react";
import styles from "./CheckModule.module.scss";

class LeftPicture extends Component {

    render() {
        const { smalltitle, 
                title,  
                subtitle1,
                text1,
                subtitle2,
                text2,
                subtitle3,
                text3,
                picture,
                alt
                } = this.props;
        return (
            <section className={styles.fh5cofeatures2}>
                <div className="container row-bottom-padded-lg row-top-padded-lg">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <span className={`${styles.fh5colabel} animate-box`}>{smalltitle}</span>
                            <h2 className={`${styles.fh5colead} animate-box`}>{title}</h2>
                            <div className={`${styles.fh5cofeature}`}>
                                <div className={`${styles.fh5coicon} animate-box`}><i className="icon-checkmark"/></div>
                                <div className={`${styles.fh5cotext} animate-box`}><h3>{subtitle1}</h3>
                                    <p>{text1}</p>
                                </div>
                            </div>
                            <div className={`${styles.fh5cofeature}`}>
                                <div className={`${styles.fh5coicon} animate-box`}><i className="icon-checkmark"/></div>
                                <div className={`${styles.fh5cotext} animate-box`}><h3>{subtitle2}</h3>
                                    <p>{text2}</p>
                                </div>
                            </div>
                            <div className={`${styles.fh5cofeature}`}>
                                <div className={`${styles.fh5coicon} animate-box`}><i className="icon-checkmark"/></div>
                                <div className={`${styles.fh5cotext} animate-box`}><h3>{subtitle3}</h3>
                                    <p>{text3}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <figure className={`${styles.fh5cofeatureimage} animate-box`}>
                                <img src={picture} alt={alt} />
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default LeftPicture;



// WEBPACK FOOTER //
// ./src/components/Section/CheckModule.jsx